<template>
    <ul class="tabs">
       <li
           v-for="(item, index) in tabs"
           :key="index"
           class="item"
           :class="{ active: activeTab === index, small: small }"
           @click="changeTabHandler(index)"
       >
            {{ item.title }}
       </li>
    </ul>
</template>

<script>
export default {
    name: "StyleTabs",

    props: {
        tabs: {
            type: Array,
            default: () => [],
        },

        activeTab: {
            type: Number,
            default: 0,
        },

        small: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        changeTabHandler(tabIndex) {
            this.$emit('change', tabIndex);
        },
    },
};
</script>

<style lang="scss" scoped>
.tabs {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
    padding: 0;
    list-style: none;
}
.item {
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 32px;
    margin-right: 16px;
    padding: 0 6px;
    flex: 1 1 0;
    border: 1px solid #E3E9F0;
    border-radius: 100px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #98A0A9;
    background-color: #FFFFFF;
    cursor: pointer;

    &.small {
        height: 24px;
        margin-right: 12px;
        flex: 0 0 auto;
        font-size: 12px;
        line-height: 16px;
    }

    &:last-of-type {
        margin: 0;
    }

    &:hover, &.active {
        border: 1px solid #D9ECFF;
        color: #4663AB;
        background: #D9ECFF;
    }
}
</style>